import React, {Component} from 'react';
import {
  Item,
  Header,
  Table,
  Icon,
  Popup,
  Button,
  Pagination,
  Input,
} from 'semantic-ui-react';
import {format} from 'date-fns';
import {Spring} from 'react-spring/renderprops';
import {PortalWithState} from 'react-portal';
import {debounce} from 'lodash';
import styled from 'react-emotion';

import searchImage from '../assets/search.svg';
import auditService from '../../store/services/audit';
import FormContainer from '../form-components/FormContainer';
import {ModalWrapper} from '../modal/ModalWrapper';
import {SerialNumberDetail} from './SerialNumberDetail';

const Styles = styled.div`
  .tableHeader {
    background-color: '#f00';
    display: flex;
    flex-grow: 1;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;

    .ui.header {
      margin-bottom: 0;
    }
  }
`;

class SearchHistory extends Component {
  state = {
    selectedResult: undefined,
    pageInfo: undefined,
    loading: false,
  };

  async componentDidMount() {
    await this._fetchResults(0);
  }

  _fetchResults = async (pageNumber, searchTerm) => {
    this.setState({loading: true});
    try {
      const {result} = await auditService.fetch({
        request: {
          page: pageNumber,
          pageSize: 20,
        },
        searchTerm: searchTerm,
      });
      this.setState({pageInfo: result});
    } catch (error) {
      this.setState({error});
    } finally {
      this.setState({loading: false});
    }
  };

  _showDetail = selectedResult => {
    this._openPortal();
    this.setState({selectedResult});
  };

  _renderDetailModal = () => {
    const {selectedResult} = this.state;

    return (
      <Spring from={{right: '-100%'}} to={{right: '0%'}}>
        {styles => (
          <ModalWrapper style={styles}>
            <SerialNumberDetail
              key={selectedResult}
              sysRowId={selectedResult}
              close={this._closePortal}
            />
          </ModalWrapper>
        )}
      </Spring>
    );
  };

  _renderRow = audit => (
    <Table.Row key={audit.id} style={{height: '60px'}}>
      <Table.Cell style={{width: 70}} textAlign="center">
        {!!audit.epicorId && (
          <Popup
            position="top center"
            trigger={
              <Button
                className="clear"
                icon
                onClick={() => this._showDetail(audit.epicorId)}
              >
                <Icon name="eye" />
              </Button>
            }
            content="VIEW"
          />
        )}
      </Table.Cell>
      <Table.Cell>{audit.type}</Table.Cell>
      <Table.Cell>{audit.identifier}</Table.Cell>
      <Table.Cell>
        {format(new Date(audit.createdDate), 'YYYY-MM-DD')}
      </Table.Cell>
    </Table.Row>
  );

  render() {
    const {loading, pageInfo = {data: []}, searchTerm} = this.state;
    return (
      <FormContainer loading={loading}>
        <Styles>
          <div className="tableHeader">
            <Header as="h1">History</Header>
            <Input
              placeholder="Search History..."
              onChange={debounce((e, searchTerm) => {
                this._fetchResults(0, searchTerm.value);
                this.setState({searchTerm: searchTerm.value});
              }, 400)}
            />
          </div>
        </Styles>
        {!!pageInfo.data.length && (
          <PortalWithState closeOnEsc>
            {({openPortal, closePortal, portal}) => {
              this._closePortal = closePortal;
              this._openPortal = openPortal;
              return (
                <React.Fragment>
                  <Table basic="very" unstackable>
                    <Table.Header>
                      <Table.Row>
                        <Table.HeaderCell style={{width: 70}} collapsing />
                        <Table.HeaderCell>Type</Table.HeaderCell>
                        <Table.HeaderCell>Identifier</Table.HeaderCell>
                        <Table.HeaderCell>Date</Table.HeaderCell>
                      </Table.Row>
                    </Table.Header>

                    <Table.Body>
                      {pageInfo.data.map(audit => this._renderRow(audit))}
                    </Table.Body>
                  </Table>
                  <Pagination
                    defaultActivePage={1}
                    onPageChange={async (e, paginationInfo) => {
                      await this._fetchResults(
                        paginationInfo.activePage - 1,
                        searchTerm
                      );
                    }}
                    ellipsisItem={{
                      content: <Icon name="ellipsis horizontal" />,
                      icon: true,
                    }}
                    firstItem={{
                      content: <Icon name="angle double left" />,
                      icon: true,
                    }}
                    lastItem={{
                      content: <Icon name="angle double right" />,
                      icon: true,
                    }}
                    prevItem={{content: <Icon name="angle left" />, icon: true}}
                    nextItem={{
                      content: <Icon name="angle right" />,
                      icon: true,
                    }}
                    totalPages={pageInfo.pageCount}
                  />
                  {portal(this._renderDetailModal())}
                </React.Fragment>
              );
            }}
          </PortalWithState>
        )}
        {pageInfo.data.length === 0 && (
          <Item.Group>
            <Item>
              <Item.Image size="mini" src={searchImage} />
              <Item.Content verticalAlign="middle">
                <strong>No history.</strong>
                <div>
                  <small>
                    Search for product documentation by serial number to build
                    you search history.
                  </small>
                </div>
              </Item.Content>
            </Item>
          </Item.Group>
        )}
      </FormContainer>
    );
  }
}

export default SearchHistory;
